import React, { Component } from "react";
import config from "../../../config";
import errorFunctions from "../../../store/errorFunctions";
import Select from "react-select";

export default class ConvertCommercialStaff extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      isLoading: true,
      customers: [],
      objCustomer: null,
      sellerValue: "",
      storeValue: null,
      locationOptions: [],
    };
  }

  componentDidMount() {
    this.retrieveStoreLocation();
  }

  handleSellerChange = (seller) => {
    const currentStoreLocation = this.state.sellerDetails.find(
      (sl) => sl.id === seller.value
    )?.store_locations;
    const storeOptions = currentStoreLocation?.length
      ? currentStoreLocation?.map((val) => {
          return { label: val.name, value: val.id };
        })
      : [];
    this.setState({
      sellerDetail: seller,
      storestoreLocation: currentStoreLocation,
      storeOptions,
    });
  };

  retrieveStoreLocation = () => {
    this.setState({
      isLoading: true,
      // deviceId: brandDevice[0]?.id,
    });
    this.props
      .protectedFetch(
        config.backendServer + "store_locations/",
        "GET",
        { country: config.country },
        errorFunctions.checkResponseThenJson
      )
      .then((res) => {
        const options = res.map((r) => {
          return { label: r.seller_name + " - " + r.name, value: r.id };
        });

        this.setState({
          isLoading: false,
          locationOptions: [...[{ label: "---", value: "" }], ...options],
        });
      })
      .catch((err) => {
        this.setState({
          isLoading: false,
        });
        console.log(err);
      });
  };

  render() {
    return (
      <div className="p-4">
        <h4>Convert Customer to Commercial Staff</h4>
        <p>
          Are you sure you want to convert this customer to commercial staff?
        </p>
        <form>
          <div key={3} className="form-input">
            <label>{"Store Location"}</label>
            <Select
              id={"storeLocation"}
              data-testid="assign-to-select"
              value={this.state.storeValue}
              isSearchable={true}
              options={this.state.locationOptions}
              isLoading={this.state.isLoading}
              onChange={(obj) => {
                this.setState({ storeValue: obj });
              }}
            />
          </div>
          <div className="row card-footer mt-4">
            <button
              className={`k-btn ${
                this.state.storeValue === null ? "btn-gray" : "btn-info"
              } col m-1`}
              disabled={this.state.storeValue === null}
              onClick={() => {
                this.props.handleConvertToCommercialStaff({
                  store_location: this.state.storeValue || "",
                });
              }}
              type="submit"
            >
              Submit
            </button>
            <button
              className={"btn btn-outline-secondary col m-1"}
              onClick={this.props.handleCloseModal}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    );
  }
}
